<div class="modal-header">
    <b>Pratica {{record.code}} - {{record.addressItem.name}}</b>
    <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="close();" >
          <i class="fas fa-times"></i>
        </button>
    </div>
</div>
<div class="modal-body">
    
    <div class="row">
        <div class="col-3">
            <small>
            <ng-container *ngFor="let p of record.phases;let i=index;">
                <div class="card border mb-1" id="{{p.id}}" [class.border-secondary]="tab==i" [class.bg-primary]="tab==i" (click)="tab=i" >                                
                    <div class="card-header bg-light pointer" title="Click per espandere/comprimere" [class.font-weight-bold]="tab_phase==i" (click)="expandPhase(p.id,tab_phase,i)" >
                        <div class="float-left">
                            {{p.title}}
                        </div>
                        <div class="float-right">
                            <span class="d-none d-lg-inline-block mr-3">
                                {{getPhaseStatus(p.id,p).date | date:"dd/MM/yyyy"}}
                                <!---
                                <span class="badge border" *ngIf="getPhaseStatus(p.id,p).state==0">da avviare</span>
                                <span class="badge badge-warning blink" *ngIf="getPhaseStatus(p.id,p).state==1">in corso</span>
                                <span class="badge badge-primary" *ngIf="getPhaseStatus(p.id,p).state==2">completata</span>
                                <span class="badge badge-danger" *ngIf="getPhaseStatus(p.id,p).state==3">annullata</span>
                                <span class="badge badge-success" *ngIf="getPhaseStatus(p.id,p).state==4">verificata</span>
                                -->
                            </span>
                            <i [title]="'da avviare'" *ngIf="getPhaseStatus(p.id,p).state==0" class="text-gray fa fa-exclamation-circle"></i>
                            <i [title]="'in corso'"  *ngIf="getPhaseStatus(p.id,p).state==1" class="text-warning far fa-clock" ></i>
                            <i [title]="'completata'" *ngIf="getPhaseStatus(p.id,p).state==2" class="text-primary fa fa-check"></i>
                            <i [title]="'annullata'" *ngIf="getPhaseStatus(p.id,p).state==3"  class="text-danger fa fa-times"></i>
                            <i [title]="'verificata'" *ngIf="getPhaseStatus(p.id,p).state==4" class="text-success fa fa-check-double"></i>
                        </div>
                                    
                    </div>
                </div>
            </ng-container>
            </small>
        </div>
        <div class="col-9">
            <div class="tab-content" id="myTabContent">
                <ng-container *ngFor="let p of record.phases;let i=index;">

                    <div class="tab-pane fade show active" *ngIf="tab==i">
                        
                        <ng-container *ngFor="let s of p.sections">
                            <h5 class="text-primary mt-3" *ngIf="s.type=='section'">{{s.name}}</h5>
                            <ul class="list-group">
                                <ng-container *ngFor="let f of s.fields">

                                    <li class="list-group-item border-bottom" *ngIf="checkEnableCondition(s.fields,f.enable_condition_fieldname)" >
                                        <!-- <span class="text-gray mr-2" title="Tipo di campo">[{{f.type}}]</span> -->
                                        <span class="mr-2">{{f.label?f.label:f.name}}:</span>
                                            <ng-container [ngSwitch]="f.type">                                                
                                                <ng-container *ngSwitchCase="'boolean'">
                                                    <b *ngIf="f['value']==1">Sì</b>
                                                    <b *ngIf="f['value'] && f['value']==0">No</b>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'date'">
                                                    <b *ngIf="f['value']">{{f['value'] | date:"dd/MM/yyyy"}}</b>
                                                    <i *ngIf="f['value']" class="ml-2">({{f['value'] | date:"EEEE"}})</i>
                                                </ng-container>                                                
                                                <ng-container *ngSwitchCase="'formula'">
                                                    <b *ngIf="f['value']">{{calculateFormula(f['value'],s.fields)}}</b>
                                                </ng-container>                                            
                                                <ng-container *ngSwitchCase="'file'">
                                                    <ng-container *ngFor="let filepath of f['value'];let i=index;">
                                                        <button class="btn btn-sm" title="Scarica/Visualizza" (click)="downloadFile(filepath)" ><i title="{{file}}" class="fa fa-file-alt"></i> File {{i+1}}</button>

                                                    </ng-container>
                                                
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'table'">
                                                    <span *ngIf="f['value']" class="text-info">[tabella]</span>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'address'">
                                                    <span *ngIf="f['value']" class="text-info">[Anagrafica]</span>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'currency'">
                                                    <b *ngIf="f['value']">{{f['value']}} Euro</b>
                                                </ng-container>                                                
                                                <ng-container *ngSwitchDefault>
                                                    <b *ngIf="f['value']">{{f['value']}}</b>
                                                </ng-container>
                                            </ng-container>
                                        <span *ngIf="!f['value']"><i class="fa fa-exclamation-triangle text-pink" title="Valore assente"></i></span>
                                    </li>
                                </ng-container>
                            </ul>
                        </ng-container>                        
                        
                    </div>            
                </ng-container>
            </div>
        </div>

    </div>

    
   
</div>
<div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="close();"><i class="fas fa-times mr-1"></i>Chiudi</button>
</div>